module.exports = new __parcel__URL__("something-wrong.d63c486f.svg").toString();